export default "__VITE_ASSET__DCHpOqTu__"